import axios from "axios";
import {BaseURL,Key} from "@project/shared/src/services/postData";
import CryptoJS from 'crypto-js';

// const CryptoJSAesJson = {
//   stringify: function (cipherParams) {
//     var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
//     if (cipherParams.iv) j.iv = cipherParams.iv.toString();
//     if (cipherParams.salt) j.s = cipherParams.salt.toString();
//     return JSON.stringify(j);
//   },
//   parse: function (jsonStr) {
//     var j = JSON.parse(jsonStr);
//     var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
//     if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
//     if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
//
//     return cipherParams;
//   }
// };


//  function encodeStringPhp(text)
// {
//   return CryptoJS.AES.encrypt(JSON.stringify(text), Key, {format: CryptoJSAesJson}).toString();
// }
//
//  function decodeStringPhp(text)
// {
//   text = JSON.stringify(text);
//   return JSON.parse(CryptoJS.AES.decrypt(text, Key, {format: CryptoJSAesJson}).toString(CryptoJS.enc.Utf8));
// }
export function ApiPostData(URLLink, tab, userData = {}, file = "") {

  // let licence =  localStorage.getItem('userData')? decodeString(localStorage.getItem("userData")):localStorage.getItem('userData');
  let licence =  localStorage.getItem('userData');


  var bodyFormData = new FormData();
  // tab = encodeStringPhp(tab);
  tab = JSON.stringify(tab);
  bodyFormData.set('tab', tab);
  for(var x=0; x < file.length; x++) {
    bodyFormData.append('file'+x, file[x]);
  }
  for(var key in userData) {
    // bodyFormData.set(key, encodeStringPhp(userData[key]));
    bodyFormData.set(key, JSON.stringify(userData[key]));
  }
  // bodyFormData.set('licence_data', encodeStringPhp(licence));
  bodyFormData.set('licence_data', JSON.stringify(licence));

  return new Promise((resolve) => {
    axios({
      method:'post',
      url:`${BaseURL}${URLLink}`,
      data: bodyFormData,
      withCredentials:true,
      config: { headers: {  'Access-Control-Allow-Origin': '*','Content-Type': 'multipart/form-data' }}
    }).then(function (response) {
      // handle success
      // let data = decodeStringPhp(response.data);
      // resolve(data);
      if(response.data.message==='Logged Out'){
        localStorage.clear();
        window.location = `${process.env.REACT_APP_WEBSITE}/login`;
      }else{
        resolve(response.data);
      }
    }).catch(function (error) {
      console.log('error in query');
      // if (error.response) {
      //   if (error.response.status === 400) {
      //     localStorage.clear();
      //    window.location = `${process.env.REACT_APP_WEBSITE}/login`;
      //   }
      // }
    });
  });

}
